export default {"src":"/_next/static/media/logo-full-long.16be8732.svg","height":145,"width":1376,"blurWidth":0,"blurHeight":0};